export default __webpack_public_path__ + "static/media/seal.4ebb6c49.svg";